/**
 * Sarvam Translate uses BCP-47 style codes like hi-IN, en-IN (see Sarvam docs).
 * Maps normalized ISO 639-1 codes from Firestore to Sarvam target_language_code.
 */

const ISO_TO_SARVAM: Record<string, string> = {
  en: 'en-IN',
  hi: 'hi-IN',
  ta: 'ta-IN',
  te: 'te-IN',
  kn: 'kn-IN',
  ml: 'ml-IN',
  mr: 'mr-IN',
  gu: 'gu-IN',
  pa: 'pa-IN',
  bn: 'bn-IN',
  ur: 'ur-IN',
  as: 'as-IN',
  or: 'od-IN',
  od: 'od-IN',
  ne: 'ne-IN',
  sa: 'sa-IN',
  sd: 'sd-IN',
  brx: 'brx-IN',
  doi: 'doi-IN',
  kok: 'kok-IN',
  mai: 'mai-IN',
  mni: 'mni-IN',
  ks: 'ks-IN',
  sat: 'sat-IN',
};

/**
 * Returns Sarvam target code, or null if English (no translation) or unsupported by Sarvam Translate.
 */
export function toSarvamTargetLanguageCode(normalizedIso: string | undefined): string | null {
  if (!normalizedIso) return null;
  const n = normalizedIso.toLowerCase();
  if (n === 'en') return null;

  if (ISO_TO_SARVAM[n]) return ISO_TO_SARVAM[n];

  const base = n.includes('-') ? n.split('-')[0] : n;
  if (ISO_TO_SARVAM[base]) return ISO_TO_SARVAM[base];

  return null;
}

/** Whether we can translate admin English copy to this locale with Sarvam. */
export function isSarvamTranslateSupported(normalizedIso: string | undefined): boolean {
  return toSarvamTargetLanguageCode(normalizedIso) !== null;
}
